export default "__VITE_ASSET__BgRkQOYZ__"